import Logger from './Logger';
import { createHandler, createSourceMapHandler } from './logHandlers';

const contextPathRegex = /^\/?([^/]+)/;

let instance = new Logger(null);
let unregisterInstance: () => void = () => {
    throw new Error('Logger wasnt registered.');
};

export default function initialize(apiPath: string, sourceMapNamespace?: string): void {
    const match = contextPathRegex.exec(apiPath);
    if (!match) throw Error(`Kan ikke lese context-path ut av ${apiPath}`);

    const contextPath = match[1];
    instance = new Logger(apiPath);

    const handler = sourceMapNamespace
        ? createSourceMapHandler(instance, sourceMapNamespace)
        : createHandler(instance, contextPath);
    unregisterInstance = () => {
        window.removeEventListener('error', handler);
    };

    window.addEventListener('error', handler);
}

export const unregister = (): void => unregisterInstance();
export const debug = <TData = unknown>(data: TData | string, rcid?: string) => instance.log<TData>('debug', data, rcid);
export const info = <TData = unknown>(data: TData | string, rcid?: string) => instance.log<TData>('info', data, rcid);
export const warn = <TData = unknown>(data: TData | string, rcid?: string) => instance.log<TData>('warn', data, rcid);
export const error = <TData = unknown>(data: TData | string, rcid?: string) => instance.log<TData>('error', data, rcid);
export { default as ErrorBoundary } from './ErrorBoundary';
export { default as getSourceMapLocation } from './getSourceMapLocation';
